<div class="container">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <div class="titleIcon">
        <mat-icon class="Icon">view_list</mat-icon>
        Generate Partner Password
      </div>
    </h1>
  </section>
  @if (password) {
    <section mat-dialog-content>
      <h2>Do you want to generate a new password for {{name}}?</h2>
      <h3>
        Password: {{password}}
        <mat-icon
          class="passwordCopy"
          matTooltip="Copy Password"
          (click)="copyPassword()"
          >content_copy</mat-icon
          >
        </h3>
      </section>
    }
    @if (!password) {
      <section mat-dialog-content>
        <h2>Do you want to generate a new password for {{name}}?</h2>
      </section>
    }
    <section align="end" mat-dialog-actions>
      <button
        mat-button
        mat-dialog-close
        matTooltip="Cancel and close."
        type="button"
        >
        <mat-icon>cancel</mat-icon>
        {{this.password ? 'Close': 'Cancel'}}
      </button>
      @if (!password) {
        <button
          [disabled]="loading"
          mat-button
          matTooltip="Update partner password."
          type="button"
          (click)="onGenerate()"
          >
          <mat-icon [ngClass]="{'loading': loading}">autorenew</mat-icon>
          Generate
        </button>
      }
    </section>
  </div>
